module.exports = __webpack_public_path__ + "static/ISO45001-logo-f458bdd168a0ca5d036dc62a5a55bf9e.svg";